import { IApplicationState } from '../../types/redux';

export function getDealType(state: IApplicationState) {
  const { tab } = state;

  return state[tab].filters.dealType;
}
